import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  helpText?: string;
  error?: string;
  suffix?: string;
}

export function Input({ label, helpText, error, suffix, id, className = '', ...props }: InputProps) {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      <label htmlFor={inputId} className="text-[11px] font-semibold tracking-widest uppercase text-white/40">
        {label}
      </label>
      <div className="relative">
        <input
          id={inputId}
          className={`
            w-full bg-white/[0.03] backdrop-blur-sm border rounded-lg px-4 py-3 text-base text-white font-mono
            placeholder:text-white/20
            focus:outline-none focus:border-white/[0.2] focus:bg-white/[0.05]
            transition-all duration-300
            ${error ? 'border-[#E84040]' : 'border-white/[0.06]'}
            ${suffix ? 'pr-10' : ''}
          `}
          {...props}
        />
        {suffix && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-white/40">
            {suffix}
          </span>
        )}
      </div>
      {helpText && !error && (
        <span className="text-[11px] text-white/40">{helpText}</span>
      )}
      {error && (
        <span className="text-[11px] text-[#E84040]" role="alert">{error}</span>
      )}
    </div>
  );
}
